import { render } from "./comCartViewMob.vue?vue&type=template&id=bedd9b5e"
import script from "./comCartViewMob.vue?vue&type=script&lang=js"
export * from "./comCartViewMob.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__